import { Injector, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TitleStrategy } from '@angular/router';
import { CustomTitleStrategy } from './core/services/title-strategy.service';
import { SideBarLayoutComponent } from './core/layout/side-bar-layout/side-bar-layout.component';
import { MenubarLayoutComponent } from './core/layout/manubar-layout/menubar-layout.component';
import { LoginComponent } from './core/auth/components/login/login.component';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from './shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { DashboardComponent } from './dashboard/components/dashboard/dashboard.component';
import { HomeComponent } from './dashboard/components/home/home.component';
import { DashboardOverviewComponent } from './dashboard/dashboard-overview/dashboard-overview.component';
import { LoaderInterceptor } from './core/auth/interceptors/loader-interceptor';
import { UserViewComponent } from './user/user-view/user-view.component';
import { UserManagementComponent } from './user/management/user-management.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AuthInterceptor } from './core/auth/interceptors/auth.interceptor';
import { APP_CONFIG } from '@mavles/shared';
import { environment } from '../environments/environment';
export let AppInjector: Injector;

@NgModule({
  declarations: [
    AppComponent,
    SideBarLayoutComponent,
    MenubarLayoutComponent,
    LoginComponent,
    DashboardComponent,
    HomeComponent,
    DashboardOverviewComponent,
    UserViewComponent,
    UserManagementComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    SharedModule,
    NgSelectModule
  ],
  providers: [
    { provide: APP_CONFIG, useValue: environment },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: TitleStrategy, useClass: CustomTitleStrategy },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}


